export default __webpack_public_path__ + "static/media/movingwaldo_md_bg.3f87af52.png";